

export function isSameDay(date, otherDate) {
	date = (date instanceof Date) && date || new Date(date)
	otherDate = (otherDate instanceof Date) && otherDate || new Date(otherDate)

	return date.getDate() == otherDate.getDate() &&
	date.getMonth() == otherDate.getMonth() &&
	date.getFullYear() == otherDate.getFullYear()
}


// WEBPACK FOOTER //
// ./lib/core/datez.js